import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_ROUTES_SUCCESS:
    case constants.GET_ROUTES_BY_PRODUCT_ID_SUCCESS:
    case constants.CREATE_ROUTES_SUCCESS:
      return Object.assign({},
        state, {
          routes: action.routes,
        });
    case constants.GET_ROUTE_SUCCESS:
    case constants.GET_ROUTE_AGGREGATE_BY_ID_SUCCESS:
    case constants.UPLOAD_ROUTE_INTRODUCTION_SUCCESS:
      return Object.assign({}, state, {
        route: action.route,
        refreshRoute: false,
      });
    case constants.POST_ROUTE_SUCCESS:
      return Object.assign({},
        state, {
          newId: action.newId,
        });
    case constants.GET_ROUTES_ERROR:
    case constants.GET_ROUTE_ERROR:
    case constants.GET_ROUTE_AGGREGATE_BY_ID_ERROR:
    case constants.GET_ROUTES_BY_PRODUCT_ID_ERROR:
    case constants.PATCH_ROUTE_ERROR:
    case constants.PATCH_STOP_ERROR:
    case constants.POST_ROUTE_ERROR:
    case constants.PUT_STOP_ERROR:
    case constants.CREATE_ROUTES_ERROR:
    case constants.UPLOAD_ROUTE_INTRODUCTION_ERROR:
      return {
        error: action.error,
      };
    case constants.PUT_STOP_SUCCESS:
    case constants.PATCH_ROUTE_SUCCESS:
    case constants.PATCH_STOP_SUCCESS:
    case constants.UPLOAD_ROUTE_INTRODUCTION:
      return Object.assign({}, state, {
        refreshRoute: true,
      });
    case constants.CLEAR_ROUTE_ERROR:
        return {
            ...state,
            error: undefined
        }
    default:
      return state;
  }
};
